var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bcbec0;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    x1: 3.83,
    y1: -158.49,
    x2: 16.17,
    y2: -158.49,
    gradientTransform: "translate(0 -149) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3250fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9e70ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2aceeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbf38"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.42,6.22c-1,.59-2.06,1.07-3.16,1.43-1.09.35-2.14.56-3.14.61-.17,0-.3.15-.3.31v1.87c0,.16.13.3.29.31.33.03.66.06.99.11,0,.04,0,.08,0,.11.08.38.14.77.16,1.16.01.19.02.34.01.49,0,.12,0,.22-.03.5,0,.04,0,.08,0,.11.04.51.53.87,1.09.84.04,0,.08,0,.11-.01.55-.09.94-.57.83-1.08-.06-.28-.08-.37-.1-.5-.02-.15-.04-.29-.05-.48-.02-.23-.02-.46-.02-.69l.15.05c1.01.32,2.06.8,3.16,1.43.15.08.34.03.42-.12.03-.05.04-.1.04-.15v-6.03c0-.17-.14-.31-.31-.31-.06,0-.11.01-.16.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11.55,7.19l4.63-1.27v.82l-4.63,1.27v-.82Zm4.63,5.04l-4.63-1.56v.83l4.61,1.55v-.04s.01-.78.01-.78Zm0-3.16h-4.63v.79h4.63v-.79Zm-12.06,1.67c.18.01.35.03.52.05v-2.58c-.17.02-.35.03-.52.04-.17,0-.3.15-.3.31v1.87c0,.16.13.3.29.31Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsicon);
export default __webpack_public_path__ + "static/media/newsicon.d06294075ecbfff0b2534fdbc596dfb6.svg";
export { ForwardRef as ReactComponent };